import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { combineLatest, Observable } from 'rxjs';
import { map, startWith, tap } from 'rxjs/operators';

import { OrderStoreDispatcher } from '@common/dispatchers/order.dispatcher';
import { AuthStoreSelector } from '@common/selectors/authentication.selector';
import { MarketplaceStoreSelector } from '@common/selectors/marketplace.selector';
import { OrderStoreSelector } from '@common/selectors/order.selector';

import {
  ORDERS_PAGE_BLOCK_LOADING_VM,
  OrdersPageBlockDataSource,
  OrdersPageBlockViewModel,
} from './orders-page-block-view-model';

@Injectable()
export class OrdersPageBlockStoreDataSource implements OrdersPageBlockDataSource {
  private readonly destroyRef = inject(DestroyRef);
  private readonly userSelector = inject(AuthStoreSelector);
  private readonly orderSelector = inject(OrderStoreSelector);
  private readonly orderDispatcher = inject(OrderStoreDispatcher);
  private readonly marketplaceSelector = inject(MarketplaceStoreSelector);

  readonly vm$: Observable<OrdersPageBlockViewModel> = combineLatest([
    this.orderSelector.selectActiveOrders,
    this.orderSelector.selectHistoricalOrders,
  ]).pipe(
    map(([activeOrders, historicalOrders]) => ({
      activeOrders,
      historicalOrders,
      isActiveOrdersLoading: false,
      isHistoricalOrdersLoading: false,
    })),
    startWith(ORDERS_PAGE_BLOCK_LOADING_VM),
  );

  constructor() {
    combineLatest([this.userSelector.selectUserId, this.marketplaceSelector.selectMarketplaceId$])
      .pipe(
        tap(([userId, marketplaceId]) => {
          if (userId) {
            this.orderDispatcher.fetchOrders(userId, marketplaceId);
          }
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
